export const tablePageRows = [15, 50, 100];
export const defaultRows = 15;

export const tablePageRowsRate = [10, 15, 20];
export const defaultRowsRate = 10;
